{
  "title": "Control de privacidad y cookies",
  "description": "Se requiere el uso de cookies con la finalidad de optimizar la navegación en nuestro sitio, desplegando anuncios adaptados y analizando las métricas de tráfico. Al presionar \"Aceptar todo\", se autoriza la habilitación de estas herramientas.",
  "acceptAll": "Aceptar todo",
  "rejectAll": "Rechazar no esenciales",
  "customize": "Configurar preferencias",
  "preferencesTitle": "Preferencias de privacidad",
  "back": "Volver",
  "savePreferences": "Confirmar selección",
  "alwaysActive": "Siempre activo",
  "categories": {
    "essential": {
      "name": "Esenciales",
      "desc": "Requeridas para garantizar la correcta operabilidad técnica de la plataforma."
    },
    "analytics": {
      "name": "Analítica",
      "desc": "Permite recopilar datos agregados de navegación orientados a la optimización de los servicios."
    },
    "marketing": {
      "name": "Marketing",
      "desc": "Utilizado para la segmentación y el despliegue de anuncios dirigidos."
    }
  }
}
